import styles from './styles.module.scss';
import { useEffect } from 'react';
import { trackMetaEvent } from '../../functions/metaPixel';

const MailchimpWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      (function($) {
        window.fnames = new Array();
        window.ftypes = new Array();
        fnames[0] = 'EMAIL';
        ftypes[0] = 'email';
        fnames[1] = 'FNAME';
        ftypes[1] = 'text';
        fnames[2] = 'LNAME';
        ftypes[2] = 'text';
        fnames[3] = 'ADDRESS';
        ftypes[3] = 'address';
        fnames[4] = 'PHONE';
        ftypes[4] = 'phone';
        fnames[5] = 'BIRTHDAY';
        ftypes[5] = 'birthday';
      }(jQuery));
      var $mcj = jQuery.noConflict(true);
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div id="mc_embed_shell" className={`d-flex w-full justify-content-center ${styles.root} wrapper `}>
      <style type="text/css">
        {`
          #mc_embed_signup {
            background: #fff;
            clear: left;
            font: 14px Helvetica, Arial, sans-serif;
            width: 600px;
          }
          /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
             We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
        `}
      </style>
      <div id="mc_embed_signup">
        <form
          action="https://gap-personnel.us4.list-manage.com/subscribe/post?u=f2e05405bc47784231288d295&amp;id=18b6ddedfa&amp;f_id=00d21ae3f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate fontFamily"
          target="_blank"
          onSubmit={() => trackMetaEvent('CompleteRegistration', { content_name: 'Newsletter signup' })}
        >
          <div id="mc_embed_signup_scroll">
            <h2>Get the latest industry news and updates in your inbox.</h2>
            <div className="indicates-required">
              <span className="asterisk">*</span> indicates required
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-EMAIL" className='mt-4'>
                Email Address <span className="asterisk">*</span>
              </label>
              <input
                type="email"
                name="EMAIL"
                className="required email inputField"
                id="mce-EMAIL"
                required
              />
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-FNAME">First Name </label>
              <input type="text" name="FNAME" className="text inputField" id="mce-FNAME" />
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-LNAME">Last Name </label>
              <input type="text" name="LNAME" className="text inputField" id="mce-LNAME" />
            </div>
            <div id="mce-responses" className="clear">
              <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
              <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
            </div>
            <div aria-hidden="true" style={{ position: 'absolute', left: '-5000px' }}>
              <input type="text" name="b_f2e05405bc47784231288d295_18b6ddedfa" tabIndex="-1" />
            </div>
            <div className="clear">
              <input type="submit" name="subscribe" id="mc-embedded-subscribe" 
              className="text-decoration-none primaryBtn m-0 d-inline-block mt-3 px-4 buttonRadius" value="Keep me updated" />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MailchimpWidget;